import { Box, ButtonLink, Inline, Link, useBreakpoint } from "@seneca/senekit";

import { Link as LinkProp } from "common/types/routing";

import Logo from "features/common/logos/Logo";
import FlagRegionLink from "features/regions/common/components/FlagRegionLink";

type Props = {
  linkToSignIn: LinkProp;
  linkToSignUp: LinkProp;
};

export default function GuestNavbar({ linkToSignIn, linkToSignUp }: Props) {
  const { isMobileOnly } = useBreakpoint();
  return (
    <Box padding={["large", "xlarge"]}>
      <Inline
        alignItems="center"
        flexWrap="nowrap"
        justifyContent="space-between"
      >
        <Link to={linkToSignUp}>
          <Logo height={["30px", "40px"]} />
        </Link>
        <Inline
          alignItems="center"
          space={["large", "xlarge"]}
          flexWrap="nowrap"
        >
          <FlagRegionLink />
          <Link to={linkToSignIn}>Login</Link>
          <ButtonLink
            size={isMobileOnly ? "small" : "standard"}
            to={linkToSignUp}
          >
            Sign up
          </ButtonLink>
        </Inline>
      </Inline>
    </Box>
  );
}
